/**
 * @module api-web:productNewDate
 */
import service from '@/service'

/**
 * 新品日期   列表
 * @param {{keywords:string,limit:number,page:number,sort:string}} params
 */
export function getList(params) {
  return service['api-web']({
    url: '/data/basic/productNewDate/getList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 新品日期   修改
 */
export function update(data) {
  return service['api-web']({
    url: '/data/basic/productNewDate/update',
    method: 'put',
    data
  })
}

/**
 * 新品日期   详情
 */
export function info(id) {
  return service['api-web']({
    url: '/data/basic/productNewDate/info',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * 待办详情 (无需权限)
 */
export function todoInfo(id) {
  return service['api-web']({
    url: '/public/activiti/productNewDate/info',
    method: 'get',
    params: { id }
  })
}
/**
 * 新品日期   新增
 */
export function create(data) {
  return service['api-web']({
    url: '/data/basic/productNewDate/save',
    method: 'post',
    data
  })
}

/**
 * @param {object}
 * @returns 审核驳回
 */
export function reject(data) {
  return service['api-web']({
    url: '/public/activiti/productNewDate/reject',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {(string|number)} ids
 * @description 结束流程（结束审核流）
 */
export function withdraw(ids) {
  return service['api-web']({
    url: '/data/basic/productNewDate/withdrawClaim',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 提交
 * @param {{ids:string}} ids
 */
export function submit(ids) {
  return service['api-web']({
    url: '/data/basic/productNewDate/submit',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * 启用禁用
 * @param {(string|number)} id - id
 * @param {(0|1)} status - 0:禁用 1:启用
 */
export function enableDisable(data) {
  return service['api-web']({
    url: '/data/basic/productNewDate/businessOperations/updateDisableStatus',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
